import React from 'react'
import Styles from './header.module.css'
import { AiOutlineLogout } from 'react-icons/ai'
import { useNavigate } from "react-router-dom"
import { useDispatch, useSelector } from 'react-redux'
import { clearUserData } from '../slices/loginSlice'
import { RxHamburgerMenu } from "react-icons/rx";
import { IoIosArrowDroprightCircle } from "react-icons/io";
import { Tooltip } from '@material-ui/core'

function Header(props) {
    const {isSidebar, toggleSideBar } = props;
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const userAdmin = useSelector(state => state.loginSlice)
    console.log("kk",userAdmin);
    
    const handleLogout = () => {
        dispatch(clearUserData())
        navigate('/login')
    }
    return (
        <div className={!isSidebar ? Styles.header : Styles.header_full}>
            {isSidebar ?
                <RxHamburgerMenu style={{ height: "3rem", width: "25px", cursor: "pointer" }} onClick={() => toggleSideBar()} /> :
                <RxHamburgerMenu style={{ height: "3rem", width: "25px", cursor: "pointer" }} onClick={() => toggleSideBar()} /> 
           } 

            <div style={{ alignItems: "center", display: "flex", marginRight: "40px", float: "right", }}>
                <div style={{ marginRight:"20px"}}>
                   {userAdmin?.email}
                </div>
                <div className='logout'>
                    <Tooltip title="Logout" color='#0a1414'>
                        <span>
                            <AiOutlineLogout style={{ height: "3rem", width: "25px", cursor: "pointer" }} onClick={handleLogout} />
                            </span>
                       </Tooltip>
                        
                </div>
            </div>
        </div>
    )
}

export default Header